/**
 * idDelEscritorio -- el id LOCAL de un producto en el escritorio (row_id_desktop, varchar en la base) como numero.
 *
 * Es lo que el escritorio espera en producto_id de un pedido del panel (T169, #35355; D #35362; OK Ares #36322).
 * Si no es un entero positivo devuelve null: nunca el codigo del producto ni el uuid de la base, que el escritorio
 * no reconoce (medido 26-oct: 3 de 169 productos tienen codigo distinto del id local).
 * Lo prueba scripts/check-producto-id-desktop.mjs.
 *
 * @module domain/value-objects/idDelEscritorio
 */
export function idLocalDelEscritorio(v) {
  const s = v === null || v === undefined ? '' : String(v).trim();
  return /^[0-9]+$/.test(s) && Number(s) > 0 ? Number(s) : null;
}
